import theme from 'reakit-theme-default'

export default {
    ...theme,
    background:"#fcfcfc",
    shadowBlur:"8",
    shadowX:"2",
    shadowY:"3",
    border:"#eee",
    roundness:"5"
}